import { ShimmerBox } from "@/components/atoms/Shimmer";

export function MapSearchSkeleton() {
  return (
    <section className="w-full py-12 md:py-16 bg-[var(--color-light-gray)]">
      <div className="container mx-auto max-w-[980px] px-4">
        {/* Search tabs */}
        <div className="flex gap-4 mb-6">
          <ShimmerBox className="h-12 w-32" />
          <ShimmerBox className="h-12 w-32" />
          <ShimmerBox className="h-12 w-32" />
        </div>
        
        {/* Map placeholder */}
        <div className="relative w-full h-[400px] md:h-[500px] bg-gray-200 rounded-lg overflow-hidden">
          <ShimmerBox className="w-full h-full" />
          
          {/* Fake map markers */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="grid grid-cols-3 gap-8">
              {[...Array(9)].map((_, i) => (
                <ShimmerBox key={i} className="w-8 h-8 rounded-full" />
              ))}
            </div>
          </div>
        </div>
        
        {/* Hotel cards slider */}
        <div className="mt-8 flex gap-4 overflow-hidden">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="flex-shrink-0 w-[280px]">
              <ShimmerBox className="h-48 w-full mb-3" />
              <ShimmerBox className="h-5 w-3/4 mb-2" />
              <ShimmerBox className="h-4 w-1/2" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
